function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { nanoid } from 'nanoid';
import * as React from 'react';
import ModalContext from './ModalContext'; // eslint-disable-next-line @typescript-eslint/ban-types

var windowStackReducer = function windowStackReducer(state, action) {
  var newWindows = _objectSpread({}, state);

  switch (action.type) {
    case 'ADD_WINDOW':
      {
        newWindows[action.id] = action.window;
        return newWindows;
      }

    case 'REMOVE_WINDOW':
      {
        delete newWindows[action.id];
        return newWindows;
      }

    case 'UPDATE_WINDOW':
      {
        newWindows[action.id] = action.window;
        return newWindows;
      }

    default:
      return state;
  }
};

var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;

  var _React$useReducer = React.useReducer(windowStackReducer, {}),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      windows = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeWindow = _React$useState2[0],
      setActiveWindow = _React$useState2[1];

  var addWindows = function addWindows(window) {
    var id = nanoid();
    dispatch({
      type: 'ADD_WINDOW',
      id: id,
      window: window
    });
    return id;
  };

  var removeWindow = function removeWindow(id) {
    dispatch({
      type: 'REMOVE_WINDOW',
      id: id
    });
  };

  var updateWindow = function updateWindow(id, window) {
    dispatch({
      type: 'UPDATE_WINDOW',
      id: id,
      window: window
    });
  };

  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: {
      windows: windows,
      addWindows: addWindows,
      removeWindow: removeWindow,
      updateWindow: updateWindow,
      setActiveWindow: setActiveWindow,
      activeWindow: activeWindow
    }
  }, children);
};

export default ModalProvider;